import { ITargetCardInfo } from '@pharmsnap/shared/types'
import { CTRL_C_INFO } from '@pharmsnap/shared/utils'
import { defineComponent, PropType } from '@vue/composition-api'
import '../../../../assets/icon-svg/target.svg'
import { BMicroEntityCard } from '../BMicroEntityCard/BMicroEntityCard'
import $classes from '../EntityCard.module.scss'
import cmpCn from '../locales/cn.json'
import cmpEn from '../locales/en.json'
import cn from './locales/cn.json'
import en from './locales/en.json'

export const BTargetCard = defineComponent({
  name: 'BTargetCard',
  i18n: {
    messages: {
      cn: { ...cn, ...cmpCn },
      en: { ...en, ...cmpEn },
    },
  },
  props: {
    data: {
      type: Object as PropType<ITargetCardInfo>,
    },
    id: {
      type: String,
      required: true,
    },
    direction: {
      type: String as PropType<'vertical' | 'horizontal'>,
      default: 'horizontal',
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    return {}
  },
  methods: {
    renderContent() {
      return <BMicroEntityCard id={this.id} type="target" direction={this.direction} data={this.data} onLoaded={() => this.$emit('loaded')} />
    },
  },
  render() {
    return (
      <div class={[$classes.card, CTRL_C_INFO, !this.border && $classes.cardNoBorder]}>
        <div class={$classes.body}>{this.renderContent()}</div>
      </div>
    )
  },
})
